import React, { useMemo } from 'react';
import { bool, func, string } from 'prop-types';
import { XData } from '@core/utils';

// devExtreme
import { Button } from 'devextreme-react/button';

export const ToolbarTemplateFileInp = ({
  fileHandler,
  disabled = false,
  labelTitle = null,
  icon = 'export'
}) => {
  const inpId = useMemo(() => XData.generateId(), []);

  return (
    <label
      className="toolbar-template-file-inp"
      title={labelTitle}
      htmlFor={inpId}
    >
      <Button
        type="normal"
        disabled={disabled}
        stylingMode="contained"
        icon={icon}
      />
      <input id={inpId} type="file" onChange={disabled ? null : fileHandler} />
    </label>
  );
};

ToolbarTemplateFileInp.propTypes = {
  fileHandler: func.isRequired,
  disabled: bool,
  labelTitle: string,
  icon: string
};
